import * as React from 'react'
import { TextInput, Elements, PhoneNumberInput } from '@tfo/common'
import { useIntl } from 'react-intl'

import './IndividualInformation.scss'

import personnummer from 'personnummer.js'

interface IndividualInfo {
    individualFirstName: string
    individualLastName: string
    individualEmail: string
    individualPhoneNumber: string
    individualNationalId: string
}

const IndividualInformationEditForm = ({ individualInfo, onChange }: {
    individualInfo: IndividualInfo
    onChange: (update: IndividualInfo, isValid: boolean) => void
}) => {
    const { Label } = Elements
    const intl = useIntl()
    const [info, setInfo] = React.useState<IndividualInfo>(individualInfo)
    const [errors, setErrors] = React.useState<{[propName: string] : boolean}>({})

    const { individualFirstName, individualLastName, individualEmail, individualPhoneNumber, individualNationalId } = info

    const onChangeValue = (propName: string, value: string, isValid: boolean) => {
        setInfo(c => ({...c, [propName]: value}))
        setErrors(e => ({...e, [propName]: isValid}))
    }

    const onInfoPropChange = (propName: string, event: React.ChangeEvent<HTMLInputElement>) => {
        const isValid = event.target.checkValidity()
        const value = event.target.value

        onChangeValue(propName, value, isValid)
    }

    const onChangePhoneNumber = (phoneNumber: string, invalid: boolean) => {
        onChangeValue('individualPhoneNumber', phoneNumber, !invalid)
    }

    React.useEffect(() => {
        if(info === individualInfo) {
            return
        }

        const allAreValid = Object.entries(errors).every(([_, isValid]) => isValid)
        onChange(info, allAreValid)
    }, [info, individualInfo, errors, onChange])

    //need to wrap individual <TextInput /> in a <span /> as the TextInput doesn't support adding classes on the wrapping element
    return (<div className='individual-info-container'>
        <span className='national-id'>
            <Label>
                {intl.formatMessage({ id: 'common.nationalid' })}
            </Label>
            <TextInput
                disabled
                value={personnummer.parse(individualNationalId, { normaliseFormat: "YYMMDD-NNNN" }).normalised} />
        </span>
        <span className='first-name'>
            <Label>
                {intl.formatMessage({ id: 'neworder.firstname.placeholder' })}
            </Label>
            <TextInput
                required
                minLength={1}
                value={individualFirstName}
                onChange={(e) => onInfoPropChange('individualFirstName', e)}
                placeholder={intl.formatMessage({ id: 'neworder.firstname.placeholder' })} /></span>
        <span className='last-name'>
        <Label>
                {intl.formatMessage({ id: 'neworder.lastname.placeholder' })}
            </Label>
            <TextInput
            required
            minLength={1}
            value={individualLastName}
            onChange={(e) => onInfoPropChange('individualLastName', e)}
            placeholder={intl.formatMessage({ id: 'neworder.lastname.placeholder' })} /></span>
        <span className='email'>
        <Label>
                {intl.formatMessage({ id: 'common.email' })}
            </Label>
            <TextInput
            required
            minLength={1}
            type='email'
            value={individualEmail}
            onChange={(e) => onInfoPropChange('individualEmail', e)}
            placeholder={intl.formatMessage({ id: 'common.email' })} /></span>
        <span className='phone-number'>
        <Label>
                {intl.formatMessage({ id: 'common.phonenumber.mobile' })}
            </Label>
            <PhoneNumberInput
            initialValue={individualPhoneNumber}
            onBlur={onChangePhoneNumber}
            placeholder={intl.formatMessage({ id: 'common.phonenumber.mobile' })} /></span>
    </div>)
}

export default IndividualInformationEditForm